import React, { MouseEventHandler, useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import axios, { AxiosResponse } from 'axios';
import 'babel-polyfill';
import {
    $disable, $enable, useSearchParams, redirectToError, formatFormPhone
} from './util';
import { Appointment, BookingInfo } from './interfaces';
import FormWrapper, { FormTextField, FormRadio, FormSubmit } from './formwrapper';
import AppointmentInfo from './appointmentinfo';
import { labels } from './labels';
import VerificationCode from './verificationcode';

interface IProps {
    name: string;
    scheduleDate: Date
}

const ContactInfo = (props: IProps) => {
    const history = useHistory();
    const [npi, start, apptType, deptid, backto] = useSearchParams(["npi", "start", "apptType", "deptid", "backto"]);

    const [appt, setAppt] = useState<Appointment>();
    const [phone, setPhone] = useState("");
    const [cellPhone, setCellPhone] = useState("");
    const [homePhone, setHomePhone] = useState("");
    const [email, setEmail] = useState("");
    const [phoneIsCell, setPhoneIsCell] = useState("");
    const [personalInfo, setPersonalInfo] = useState<BookingInfo>(new BookingInfo());
    const [showVerification, setShowVerification] = useState(false);
    const [verifyMode, setVerifyMode] = useState("");

    useEffect(() => {
        axios.get(`api/appointments?npi=${npi}&start=${start}&deptid=${deptid}`)
            .then((result) => {
                if (result.data) {
                    setAppt(result.data);
                    getPersonalInfo();
                } else {
                    history.push(`/contactprovider${window.location.search}&error=INVALID_APPT`);
                }
            }).catch((result) => {
                history.push(`/contactprovider${"" + window.location.search}`);
            })
    }, [])

    function getPersonalInfo() {
        axios.get(`api/appointments/GetPersonalInfo`)
            .then((result) => {
                if (!result.data.firstName) {
                    history.push(`/personalinfo${"" + window.location.search}`);
                } else {
                    setPersonalInfo(result.data);
                    setPhone(formatFormPhone(result.data.cellPhone || result.data.homePhone));
                    setPhoneIsCell((result.data.cellPhone || result.data.homePhone) ? (result.data.cellPhone ? "true" : "false") : "");
                    setCellPhone(result.data.cellPhone);
                    setHomePhone(result.data.homePhone);
                    setEmail(result.data.email);
                }
            })
    }

    function savePersonalInfo(e: React.MouseEvent<HTMLElement>) {
        e.preventDefault();
        $disable("verifyButton");

        let verifiedEmail = (email === personalInfo.email && personalInfo.emailVerified);
        let verifiedPhone = cellPhone === personalInfo.cellPhone && personalInfo.cellPhoneVerified
        var verify = '';
        if (!verifiedEmail && !verifiedPhone) {
            if (document.getElementById("verifyFeedback")) {
                document.getElementById("verifyFeedback").style.display = "none";
                if (document.forms[0].verifyMode) {
                    verify = document.forms[0].verifyMode.value;

                    if (!verify) {
                        document.getElementById("verifyFeedback").style.display = "block";
                        $enable("verifyButton");
                        return;
                    }
                }
            }
        }

        /*
        if (verifyCellPhone || verifyEmail) {
            $setText("verifyButton", "Sending verification code...");
        }*/

        var fields = ["email"];
        var info = { npi, startTime: start, departmentId: deptid, apptType } as BookingInfo;
        if (phoneIsCell === "true") {
            info.cellPhone = phone;
            info.homePhone = '';
        } else {
            info.homePhone = phone;
            info.cellPhone = '';
        }
        document.getElementById('phoneIsCell').classList.remove('is-invalid');
        FormSubmit("UPDATE_CONTACT_INFO", `api/appointments/SaveContactInfo?verify=${verify}&phoneIsCell=${phoneIsCell}`, fields, info,
            (response) => {
                $enable("verifyButton");
                //alert(JSON.stringify(response));
                if (response.data.indexOf("VERIFY_") === 0) {
                    setVerifyMode(response.data);
                    setShowVerification(true);
                } else if (response.data === "VERIFIED_EMAIL" || response.data === "VERIFIED_CELLPHONE") {
                    history.push(`/insuranceinfo${"" + window.location.search}`);
                }
            },
            (r) => {
                $enable("verifyButton");
                console.log(JSON.stringify(r));
                //redirectToError(window.location.search, r.error);
            },
            (r) => {
                $enable("verifyButton");
                console.log(JSON.stringify(r));
                redirectToError(window.location.search, r.error);
            }
        );
    }

    if (!appt) return (<div></div>)

    let emailVerified = (email === personalInfo.email && personalInfo.emailVerified);
    let phoneVerified = cellPhone === personalInfo.cellPhone && personalInfo.cellPhoneVerified;
    let needsVerification = !(emailVerified || phoneVerified);
    let verifiedText = <span><strong>&#128504; Verified</strong></span>;

    return (
        <FormWrapper currentStep={3}>
            {/*<FormProgress currentStep={3} />*/}
            <AppointmentInfo appt={appt} apptType={apptType} />

            <h2 className="mb-3 mt-3">{labels.contactinfo.title}</h2>
            {/*
            {needsVerification && personalInfo.dateOfBirth &&
                <div className="mt-1 mb-3">{
                    <ol className="contactInfoDirections">
                        {labels.contactinfo.instructions.map((m) => <li>{m}</li>)}
                    </ol>
                }
                </div>} */}
            <div className="row">
                <div className="col-md-6 mb-3">
                    <div className="row">
                        <FormTextField className="col-md mb-3" id="email" label="Email" label2={emailVerified ? verifiedText : ""} placeholder="name@example.com" value={email} onChange={(e) => setEmail(e.target.value)} maxLength={50} required />
                    </div>
                    <div className="row">
                        <FormTextField className="col-md mb-3" id="phone" label="Phone" label2={phoneVerified ? verifiedText : ""} placeholder="123-456-7890" value={phone} onChange={(e) => setPhone(e.target.value)} mask="phone" required
                            invalidText="Please provide a cell phone and/or home phone" />
                    </div>
                    <div className="mb-3">
                        Is this a cell phone?* <input style={{ marginLeft: "20px" }} id="phoneIsCell" name="phoneIsCell" type="radio" checked={phoneIsCell == "true"}
                            onChange={(e) => { setPhoneIsCell(e.target.checked ? "true" : "false"); document.getElementById('phoneIsCell').classList.remove('is-invalid'); }} /> <label htmlFor="phoneIsCell">Yes</label>
                        <input style={{ marginLeft: "20px" }} id="phoneIsNotCell" name="phoneIsCell" type="radio" checked={phoneIsCell == "false"}
                            onChange={(e) => { setPhoneIsCell(e.target.checked ? "false" : "true"); document.getElementById('phoneIsCell').classList.remove('is-invalid'); }} /> <label htmlFor="phoneIsNotCell">No</label>
                        <div style={{ marginTop: "-8px"}} className="invalid-feedback">Required</div>
                    </div>
                    {/*
                    <div className="row">
                        <FormTextField className="col-md mb-3" id="cellPhone" label="Cell Phone" placeholder="123-456-7890" value={homePhone} onChange={(e) => setCellPhone(e.target.value)} mask="phone"
                            invalidText="Please provide a cell phone and/or home phone" />
                    </div>
                    <div className="row">
                        <FormTextField className="col-md mb-3" id="homePhone" label="Home Phone" placeholder="123-456-7890" value={homePhone} onChange={(e) => setHomePhone(e.target.value)} mask="phone"
                            invalidText="Please provide a cell phone and/or home phone" />
                    </div>*/}
                </div>
                {needsVerification && personalInfo.dateOfBirth && phone && email && (phoneIsCell == "true") &&
                    <div className="col-md-6 mb-3">
                        <h4 className="mb-3">{labels.contactinfo.verificationMethod}</h4>
                        <p>{labels.contactinfo.verificationText}</p>
                        <div id="verifyFeedback" className="invalid-feedback mb-3">
                            Please select a verification method
                        </div>

                        <FormRadio id="verifyByText" name="verifyMode" value="text">
                            <strong>Text: </strong> Send verification code by text to your cell phone
                        </FormRadio>

                        <FormRadio id="verifyByEmail" name="verifyMode" value="email">
                            <strong>Email: </strong> Send verification code by email
                        </FormRadio>

                        <FormRadio id="verifyByBoth" name="verifyMode" value="both">
                        <strong>Both: </strong> Send verification code by text and email
                        </FormRadio>
                        <p className="small">For text messages, message and data rates may apply.</p>
                    </div>}
                {needsVerification && personalInfo.dateOfBirth && email && phone && phoneIsCell == "false" &&
                    <div className="col-md-6 mb-3">
                    <h4 className="mb-3">{labels.contactinfo.verificationMethod}</h4>
                        <p>{labels.contactinfo.emailVerificationText}</p>
                        <FormRadio id="verifyByEmail" name="verifyMode" value="email" checked={true}>
                            <strong>Email: </strong> Send verification code by email
                        </FormRadio>
                    </div>
                }
            </div>

            <hr className="mb-4" />

            <div className="row">
                <div className="col-md mb-4">
                    <button id="verifyButton" className="btn btn-primary btn-block" type="submit" onClick={savePersonalInfo}>Continue</button>
                </div>
                <div className="col-md mb-4">
                    <button className="btn btn-outline-primary btn-block" type="submit" onClick={(e) => { e.preventDefault(); history.push(`personalinfo${window.location.search}`) }}>{labels.contactinfo.backTo}</button>
                </div>
            </div>
            <VerificationCode show={showVerification} mode={verifyMode} onClose={() => { setShowVerification(false) }} />
        </FormWrapper>
    );
}

export default ContactInfo;